import { Component, OnInit, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ApiService } from 'src/app/shared/api';

import { register } from 'swiper/element/bundle';
register();

import * as moment from 'moment';
moment.locale('de');

@Component({
	selector: 'dashboard-news',
	templateUrl: './news.component.html',
	styleUrls: ['./news.component.scss'],
})


export class NewsComponent implements OnInit {

	@Input() mode: string = 'content';

	newsArr: any[] = [
		{
			img: '../../../assets/characters/character-2.png',
			infoTitle: 'Neuigkeiten',
			infoDes: 'verfasst von Andreas am 15.01.2024',
			title: 'Neue Funktionen zum Testen',
			des: 'Wir arbeiten an neuen Unterseiten. Solange sind diese im Menü ausgegraut. Sobald sie vollumfänglich fertigstellt sind, werden diese für Sie zum Testen freigeschaltet.',
			link: '#',
		},
		{
			img: '../../../assets/characters/character-1.png',
			infoTitle: 'Funnel / LMS',
			infoDes: 'verfasst von Andreas am 15.01.2024',
			title: 'Der Funnel/Formular Baukasten',
			des: 'Weitere Infos folgen in Kürze. Wir informieren Sie hier über alle Neuerungen.',			
			link: '#',
		},
		{
			img: '../../../assets/characters/character-2.png',
			infoTitle: 'Leads / Aufgaben',
			infoDes: 'verfasst von Andreas am 15.01.2024',
			title: 'Aufgaben Board für Ihre Leads',
			des: 'Weitere Infos folgen in Kürze. Wir informieren Sie hier über alle Neuerungen.',			
			link: '#',
		},
		{
			img: '../../../assets/characters/character-2.png',
			infoTitle: 'Dashboard',
			infoDes: 'verfasst von Andreas am 15.01.2024',
			title: 'Neue Dashboard Funktionen',
			des: 'Weitere Infos folgen in Kürze. Wir informieren Sie hier über alle Neuerungen.',
			link: '#',
		},
	]

	constructor(private apiService: ApiService) { }

	ngOnInit() {
	}
	ngAfterViewInit() {
		const swiperEl = document.querySelector('swiper-container');
		const swiperParams = {
			slidesPerView: 1.1,
			spaceBetween: 20,
			pagination: true,
			// swipeHandler: true,
			
			breakpoints: {
				575: {
				  slidesPerView: 1.2,
				},
				1120: {
					slidesPerView: 1.5,
				},
				1400: {
					slidesPerView: 'auto',
			  	},
			},
			on: {
			  init() {
				// ...
			  },
			},
		  };
		
		  // now we need to assign all parameters to Swiper element
		  Object.assign(swiperEl, swiperParams);
		
		  // and now initialize it
		  swiperEl.initialize();
	}
}
